export const emailRegExp: RegExp = /^(\w+(([\.+]|-{1,2})\w+)*(\.?[-_])*)@\w+(?:[\.-]\w+)*(?:\.[a-zA-Z]{2,15})$/;
export const onlyLatinCharactersRegExp: RegExp = /^[a-zA-Z0-9][a-zA-Z0-9 *_\-!#$%^><&,."\\']*$/;
export const checkForOnlySameLatinCharactersRegExp: RegExp =
  /^(?=(?!(.).*\1{2,}).*)(^[0-9a-zA-Z].*[a-zA-Z0-9()*_\-!#$%^><&*,."\'\\])$/;
export const companyNameMaxLength: string = '200';
export const tradingNameMaxLength: string = '200';
export const companyNumberMaxLength: string = '100';
export const regulatorNameMaxLength: string = '250';
export const purposeOfPaymentsMaxLength: string = '400';
export const addressLineMinLength: string = '3';
export const addressLineMaxLength: string = '100';
export const taxIdMinLength = '9';
export const taxIdMaxLength = '9';
export const sicCodeMinLength = '5';
export const sicCodeMaxLength = '5';
export const onlyDigitsRegExp = /^[0-9]*$/;
export const cityRegExp: RegExp = /^[a-zA-Z\s]*$/;
export const postcodeRegExp: RegExp = /^(([a-zA-Z0-9 ]{1,10})|(\\d{5}(?:-\\d{4})?))$/;
export const checkForOnlySameCharactersRegExp: string = '^(?!.*(.).*\\1{1,}).*';
export const phoneRegExp: string = '^\\d{5,18}$';
export const ownershipPercentageRegExp: string = '(^100([.]0{1,2})?)$|(^(2[5-9]|[3-9][0-9]|99)([.]\\d{1,2})?)$';
export const websiteRegExp: string =
  '^([w|W]{3}\\.)([a-zA-Z0-9+_-]+)(\\.([a-zA-Z0-9+_-]+))?\\.([a-zA-Z]+)(\\/[a-zA-Z0-9-_=.%/]+)*$';
export const socialSecurityNumberRegExp: string = '^\\d{9}$';
export const questionRegExp: RegExp = /^[a-zA-Z0-9][a-zA-Z0-9 *_\-!#$%^><&,."\\']*$/;
